import { Link } from "react-router-dom";
import Header from "../../components/layout/Header";
import Footer from "../../components/layout/Footer";
import SEO from "../../components/SEO";
import { SITE_URL } from "../../config/site";
import "./LegalPages.css";

export default function LegalNoticePage() {
  return (
    <>
      <SEO
        title="Aviso legal | Imalandia"
        description="Información legal y datos de contacto del sitio web Imalandia."
        canonical={`${SITE_URL}/aviso-legal`}
        noindex
      />

      <Header />

      <main className="legal-page">
        <div className="legal-container">
          <p className="legal-eyebrow">INFORMACIÓN LEGAL</p>
          <h1>Aviso legal</h1>

          <div className="legal-content">
            <p>Última actualización: 30 de julio de 2026.</p>

            <h2>1. Datos de contacto</h2>

            <dl className="legal-contact-data">
              <div>
                <dt>Titular del sitio</dt>
                <dd>imalandia.com</dd>
              </div>
              <div>
                <dt>Correo electrónico</dt>
                <dd>
                  <a href="mailto:info@imalandia.com">info@imalandia.com</a>
                </dd>
              </div>
              <div>
                <dt>Teléfono</dt>
                <dd>
                  <a href="tel:+34646273415">646 273 415</a>
                </dd>
              </div>
            </dl>

            <h2>2. Finalidad de este aviso</h2>

            <p>
              Este documento identifica a la persona responsable del sitio y
              establece sus reglas generales de acceso y uso. Las compras,
              pagos, envíos y devoluciones se regulan separadamente en los{" "}
              <Link to="/terminos">Términos y condiciones</Link>.
            </p>

            <h2>3. Uso del sitio</h2>

            <p>
              El usuario debe utilizar la web de forma lícita y responsable. No
              está permitido intentar alterar su funcionamiento, introducir
              código dañino, acceder a zonas restringidas o utilizar sus
              servicios para vulnerar derechos de terceros.
            </p>

            <h2>4. Propiedad intelectual</h2>

            <p>
              El diseño, los textos, la marca y los contenidos propios de la web
              están protegidos por la normativa aplicable. No pueden
              reproducirse o explotarse comercialmente sin autorización, salvo
              en los casos permitidos por la ley.
            </p>

            <h2>5. Disponibilidad y enlaces externos</h2>

            <p>
              La web puede interrumpirse temporalmente por mantenimiento,
              incidencias técnicas o causas ajenas. Los sitios externos
              enlazados, cuando existan, son responsabilidad de sus respectivos
              titulares.
            </p>

            <h2>6. Legislación aplicable</h2>

            <p>
              Este aviso se rige por la legislación española. Para comunicar
              cualquier problema relacionado con el sitio puede utilizarse el
              correo o el teléfono indicados al comienzo de esta página.
            </p>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
}
